import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const OutdoorDinningIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "OutdoorDinningIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.69073 17.2784C7.61415 17.01 7.36893 16.8249 7.08985 16.8249H3.33984V10.5748C3.33984 10.2297 3.06002 9.94984 2.71484 9.94984C2.36966 9.94984 2.08984 10.2297 2.08984 10.5748V21.8249C2.08984 22.17 2.36966 22.4499 2.71484 22.4499C3.06002 22.4499 3.33984 22.17 3.33984 21.8249V18.0749H6.61835L7.73898 21.9964C7.81556 22.2647 8.06078 22.4498 8.33986 22.4499C8.39805 22.4497 8.45594 22.4417 8.51199 22.4261C8.84371 22.331 9.03573 21.9852 8.94105 21.6534L7.69073 17.2784Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.4649 9.94984C21.1197 9.94984 20.8399 10.2297 20.8399 10.5748V16.8249H17.0899C16.8108 16.8249 16.5656 17.01 16.489 17.2784L15.239 21.6534C15.1443 21.9852 15.3363 22.331 15.6681 22.4261C15.7241 22.4417 15.782 22.4497 15.8402 22.4499C16.1191 22.4497 16.3642 22.2646 16.4407 21.9964L17.5614 18.0749H20.8399V21.8249C20.8399 22.17 21.1197 22.4499 21.4649 22.4499C21.8101 22.4499 22.0899 22.17 22.0899 21.8249V10.5748C22.0899 10.2297 21.8101 9.94984 21.4649 9.94984Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.965 21.1999H12.715V15.5749H17.09C17.7801 15.5741 18.3393 15.0149 18.34 14.3249V13.0749C18.3393 12.3848 17.7801 11.8257 17.09 11.8249H12.715V8.07485H18.34C18.6849 8.07514 18.9648 7.79577 18.9651 7.45087C18.9651 7.36594 18.9479 7.28189 18.9144 7.20385C17.6199 4.18266 15.1323 2.44984 12.09 2.44984C9.04772 2.44984 6.56021 4.18266 5.26571 7.20385C5.12957 7.52075 5.27611 7.88801 5.593 8.02414C5.67104 8.05766 5.75509 8.07492 5.84002 8.07485H11.465V11.8249H7.09002C6.39999 11.8257 5.84081 12.3848 5.84002 13.0749V14.3249C5.84081 15.0149 6.39999 15.5741 7.09002 15.5749H11.465V21.1999H10.215C9.86985 21.1999 9.59003 21.4797 9.59003 21.8249C9.59003 22.1701 9.86985 22.4499 10.215 22.4499H13.965C14.3102 22.4499 14.59 22.1701 14.59 21.8249C14.59 21.4797 14.3102 21.1999 13.965 21.1999ZM12.09 3.69984C14.2803 3.69172 16.2961 4.89387 17.3299 6.82485H6.85015C7.884 4.89388 9.89973 3.69172 12.09 3.69984ZM7.09002 13.0749H17.09V14.3249H7.09002V13.0749Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default OutdoorDinningIcon;
